import { trackerApi } from "../../../core/api/TrackerApi";
import { DefaultAutocomplete, DefaultAutocompleteProps } from "../../../core/components/autocomplete/DefaultAutocomplete";
import { useQueryArray } from "../../../core/components/helpers/queryHelper";

export interface CategoryAutocompleteDto {
    id: number,
    name: string
}


const fetchCategories = async (): Promise<Array<CategoryAutocompleteDto>> => {



    const data = await trackerApi.callServiceGet('/oot/generator/categories')
    return data
}

interface CategoryAutocompleteProps extends DefaultAutocompleteProps<CategoryAutocompleteDto> {
    selection: CategoryAutocompleteDto | null
}

export const CategoryAutocomplete = (props: CategoryAutocompleteProps) => {


    const queryCategoryAutocomplete = useQueryArray<CategoryAutocompleteDto>(['/oot/generator/categories'], () => fetchCategories(), 'Category Autocomplete');

    return (
        <DefaultAutocomplete<CategoryAutocompleteDto>
            {...props}
            onChange={props.onChange}
            query={queryCategoryAutocomplete}
            displayFieldName='name'
            label="OoT Category"
            selection={props.selection}
        />
    )
}